// extracted by mini-css-extract-plugin
export default {"inputWrapper":"DateInput_inputWrapper__ajduh","label":"DateInput_label__CoEYE","error":"DateInput_error__ESMQB","input":"DateInput_input__2fpEu"};